import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  start(campaignId) {
    return axios.post(`${this.url}/${campaignId}/start`);
  }

  pause(campaignId) {
    return axios.post(`${this.url}/${campaignId}/pause`);
  }

  cancel(campaignId) {
    return axios.post(`${this.url}/${campaignId}/cancel`);
  }

  getUsage() {
    return axios.get(`${this.url}/usage`);
  }
}

export default new CampaignsAPI();
